var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('li',[(_vm.menuItem.url)?_c('UiLink',{staticClass:"hover:underline",class:{ active: _vm.isActive },attrs:{"to":_vm.menuItem.url}},[_vm._v("\n    "+_vm._s(_vm.menuItem.name)+"\n  ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }